import React from 'react';
import { RulesModal } from '../../Modals/RulesModal/RulesModal';
import { FailedGameModal } from '../../Modals/FailedGameModal/FailedGameModal';
import { trainingModeRules } from '../../../api';
import TrainingModeResultModal from '../../Modals/TrainingModeResultModal/TrainingModeResultModal';

interface ITrainingModals {
  showResultModal: boolean;
  handleResultModalClose: () => void;
  setIsStreetView: (value: boolean) => void;
  setIsTimerDisabled: (value: boolean) => void;
  showFailedGameModal: boolean;
  setShowFailedGameModal: (value: boolean) => void;
  fetchDataFunction: () => Promise<void>;
  showRulesModal: boolean;
  setShowRulesModal: (value: boolean) => void;
  disableTries: boolean;
  attempts?: number;
  setIsLocationSubmitted: (value: boolean) => void;
  refreshGoogleMap: () => void;
}

const TrainingModals: React.FC<ITrainingModals> = ({
  showResultModal,
  handleResultModalClose,
  setIsStreetView,
  setIsTimerDisabled,
  showFailedGameModal,
  setShowFailedGameModal,
  fetchDataFunction,
  showRulesModal,
  setShowRulesModal,
  disableTries,
  attempts,
  setIsLocationSubmitted,
  refreshGoogleMap,
}) => {
  return (
    <>
      <RulesModal
        showRulesModal={showRulesModal}
        setShowRulesModal={setShowRulesModal}
        rules={trainingModeRules}
      />
      <TrainingModeResultModal
        open={showResultModal}
        handleClose={handleResultModalClose}
        setIsStreetView={setIsStreetView}
        setIsTimerDisabled={setIsTimerDisabled}
        disableTries={disableTries}
        attempts={attempts}
        setIsLocationSubmitted={setIsLocationSubmitted}
        refreshGoogleMap={refreshGoogleMap}
      />
      <FailedGameModal
        setIsStreetView={setIsStreetView}
        showFailedGameModal={showFailedGameModal}
        setShowFailedGameModal={setShowFailedGameModal}
        fetchDataFunction={fetchDataFunction}
        setIsTimerDisabled={setIsTimerDisabled}
        disableTries={disableTries}
        attempts={attempts}
        setIsLocationSubmitted={setIsLocationSubmitted}
        refreshGoogleMap={refreshGoogleMap}
      />
    </>
  );
};

export default TrainingModals;
